var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSystems(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    clipRule: "evenodd",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M71.484 14.267c0-4.696-3.813-8.509-8.509-8.509H17.639c-4.697 0-8.51 3.813-8.51 8.509 0 4.697 3.813 8.51 8.51 8.51h45.336c4.696 0 8.509-3.813 8.509-8.51zm-52.402 0h1.349m7.317 0h1.349m31.222 0H45.952m19.035 24.987c0-4.696-3.813-8.509-8.51-8.509H11.141c-4.696 0-8.509 3.813-8.509 8.509 0 4.004 2.771 7.365 6.497 8.27m3.456-8.27h1.349m7.317 0H22.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fill stroke",
    d: "M31.427 47.345c2.442-5.332 7.827-9.04 14.072-9.04 6.35 0 11.812 3.836 14.194 9.316a10.904 10.904 0 011.791-.147c6.007 0 10.884 4.877 10.884 10.884 0 6.007-4.877 10.884-10.884 10.884H19.276c-4.905 0-8.888-3.982-8.888-8.888 0-4.905 3.983-8.888 8.888-8.888 1.113 0 2.179.205 3.161.58a10.94 10.94 0 018.99-4.701h0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M39.997 50.213a6.386 6.386 0 015.307-2.83 6.394 6.394 0 015.793 3.69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystems);
export default __webpack_public_path__ + "static/media/systems.3e116c18aaac520f3ee7090c3bf1c5c8.svg";
export { ForwardRef as ReactComponent };